const components = {
  install(app) {
    const { $componentsManager } = app.config.globalProperties;
    if (!$componentsManager) {
      return;
    }
    $componentsManager.addSettings({
      components: {
        BanzaButton: {
          presets: {
            surveyChoiceValue: {
              class: "px-2 rounded-lg",
              // isClassOverride: true,
              attrs: {
                variant: "text",
                size: "small",
                color: "blue-grey"
              },
              slots: {
                icon: {
                  attrs: {
                    icon: "mdi-format-text",
                    right: true
                  }
                }
              }
            },
            completeSurvey: {
              class: "text-white",
              attrs: {
                variant: "flat",
                color: "#726AF3"
              }
            },
            nextPage: {
              preset: "BanzaButton.completeSurvey",
              slots: {
                icon: {
                  attrs: {
                    right: true,
                    icon: "mdi-chevron-right"
                  }
                }
              }
            },
            prevPage: {
              slots: {
                icon: {
                  attrs: {
                    icon: "mdi-chevron-left"
                  }
                }
              }
            }
          }
        }
      },
      colorScheme: {
        light: {
          "editable-label-bg": "#EEF7EA"
        }
      }
    });
  }
};
export {
  components as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
